module.exports = __webpack_public_path__ + "img/origin_export_pdf_bg.caf70c17.svg";